import type { ProductVariantExtended } from '~~/types/product/ProductVariantExtended';
import type { Breadcrumb } from '~~/types/product/Breadcrumb';

export const getBreadcrumbsFromProduct = (product: ProductVariantExtended): Breadcrumb[] => {

  return product?._breadcrumbs?.[0] ?? [];

};
